// extracted by mini-css-extract-plugin
export default {"App":"App_App__TmSC5","Main":"App_Main__DkBeN","ColorNav":"App_ColorNav__VHHJ4"};